var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-drawer",
    {
      staticClass: "edi-detail-drawer",
      attrs: {
        visible: _vm.visible,
        direction: "rtl",
        size: "680px",
        "modal-append-to-body": false,
        "wrapper-closable": false,
        "before-close": _vm.handleClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("template", { slot: "title" }, [
        _c("div", { staticClass: "drawer-title" }, [
          _vm._v(_vm._s(_vm.detailData.orderNo)),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "drawer-body" },
        [
          _c("div", { staticClass: "summary-grid" }, [
            _c(
              "div",
              { staticClass: "summary-card" },
              [
                _c("div", { staticClass: "summary-label" }, [
                  _vm._v(
                    _vm._s(_vm.$t("ExternalOrders.EDI.detailCurrentStep"))
                  ),
                ]),
                _c(
                  "el-tag",
                  {
                    attrs: {
                      size: "mini",
                      type: _vm.isException ? "danger" : "success",
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(_vm.filterList.bjGet(_vm.detailData.statusLabel))
                      )
                    ),
                  ]
                ),
                _vm.isException && _vm.exceptionReason
                  ? _c("div", { staticClass: "exception-reason" }, [
                      _c("span", [_vm._v(_vm._s(_vm.exceptionReason))]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _c("div", { staticClass: "summary-card" }, [
              _c("div", { staticClass: "summary-label" }, [
                _vm._v(_vm._s(_vm.$t("ExternalOrders.EDI.detailActionOwner"))),
              ]),
              _c("div", { staticClass: "summary-value" }, [
                _vm._v(_vm._s(_vm.detailData.actionOwner)),
              ]),
            ]),
          ]),
          _c("BjDivider", { attrs: { size: "mini" } }, [
            _vm._v(_vm._s(_vm.$t("ExternalOrders.EDI.detailOrderNumbers"))),
          ]),
          _c("dl", { staticClass: "info-list" }, [
            _c("dt", [
              _vm._v(_vm._s(_vm.$t("ExternalOrders.EDI.detailRetailerPo"))),
            ]),
            _c("dd", [_vm._v(_vm._s(_vm.detailData.orderNo || "——"))]),
            _c("dt", [
              _vm._v(_vm._s(_vm.$t("ExternalOrders.EDI.detailClientErpNo"))),
            ]),
            _c("dd", [_vm._v(_vm._s(_vm.detailData.orderNoErp || "——"))]),
            _c("dt", [
              _vm._v(_vm._s(_vm.$t("ExternalOrders.EDI.detailCsgOrderNo"))),
            ]),
            _c("dd", [_vm._v(_vm._s(_vm.detailData.orderNoWms || "——"))]),
            _c("dt", [
              _vm._v(_vm._s(_vm.$t("ExternalOrders.EDI.columnStore"))),
            ]),
            _c("dd", [_vm._v(_vm._s(_vm.detailData.erpStoreName || "——"))]),
            _c("dt", [
              _vm._v(_vm._s(_vm.$t("ExternalOrders.EDI.columnReceived"))),
            ]),
            _c("dd", { staticClass: "info-time" }, [
              _vm._v(_vm._s(_vm._f("timeFilters")(_vm.detailData.createdDate))),
            ]),
          ]),
          _vm.hasHistories
            ? _c("BjDivider", { attrs: { size: "mini" } }, [
                _vm._v(
                  _vm._s(_vm.$t("ExternalOrders.EDI.detailProcessingTimeline"))
                ),
              ])
            : _vm._e(),
          _vm.hasHistories
            ? _c(
                "div",
                { staticClass: "timeline-list" },
                _vm._l(_vm.detailData.histories, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "timeline-item" },
                    [
                      _c("span", { staticClass: "timeline-index" }, [
                        _vm._v(_vm._s(index + 1)),
                      ]),
                      _c("span", { staticClass: "timeline-label" }, [
                        _vm._v(_vm._s(item.message)),
                      ]),
                      _c("span", { staticClass: "timeline-time" }, [
                        _vm._v(_vm._s(_vm._f("timeFilters")(item.createdDate))),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
          _vm.hasShippingLocation
            ? _c("BjDivider", { attrs: { size: "mini" } }, [
                _vm._v(
                  _vm._s(_vm.$t("ExternalOrders.EDI.detailDeliveryAddress"))
                ),
              ])
            : _vm._e(),
          _vm.hasShippingLocation
            ? _c("div", { staticClass: "address-card" }, [
                _c("div", { staticClass: "address-field" }, [
                  _c("div", { staticClass: "address-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("ExternalOrders.EDI.detailRecipient"))
                    ),
                  ]),
                  _c("div", { staticClass: "address-value" }, [
                    _vm._v(_vm._s(_vm.deliveryAddress.recipient)),
                  ]),
                ]),
                _c("div", { staticClass: "address-field" }, [
                  _c("div", { staticClass: "address-label" }, [
                    _vm._v(_vm._s(_vm.$t("ExternalOrders.EDI.detailPhone"))),
                  ]),
                  _c("div", { staticClass: "address-value" }, [
                    _vm._v(_vm._s(_vm.deliveryAddress.phone)),
                  ]),
                ]),
                _c("div", { staticClass: "address-field address-field-full" }, [
                  _c("div", { staticClass: "address-label" }, [
                    _vm._v(_vm._s(_vm.$t("ExternalOrders.EDI.detailAddress"))),
                  ]),
                  _c("div", { staticClass: "address-value" }, [
                    _vm._v(_vm._s(_vm.deliveryAddress.address)),
                  ]),
                ]),
                _c("div", { staticClass: "address-field" }, [
                  _c("div", { staticClass: "address-label" }, [
                    _vm._v(_vm._s(_vm.$t("ExternalOrders.EDI.detailSuburb"))),
                  ]),
                  _c("div", { staticClass: "address-value" }, [
                    _vm._v(_vm._s(_vm.deliveryAddress.suburb)),
                  ]),
                ]),
                _c("div", { staticClass: "address-field" }, [
                  _c("div", { staticClass: "address-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("ExternalOrders.EDI.detailStatePostcode"))
                    ),
                  ]),
                  _c("div", { staticClass: "address-value" }, [
                    _vm._v(_vm._s(_vm.deliveryAddress.statePostcode)),
                  ]),
                ]),
                _c("div", { staticClass: "address-field" }, [
                  _c("div", { staticClass: "address-label" }, [
                    _vm._v(_vm._s(_vm.$t("ExternalOrders.EDI.detailCountry"))),
                  ]),
                  _c("div", { staticClass: "address-value" }, [
                    _vm._v(_vm._s(_vm.deliveryAddress.country)),
                  ]),
                ]),
              ])
            : _vm._e(),
          _c("BjDivider", { attrs: { size: "mini" } }, [
            _vm._v(_vm._s(_vm.$t("ExternalOrders.EDI.detailOrderLines"))),
          ]),
          _c(
            "el-tabs",
            {
              staticClass: "order-lines-tabs",
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("ExternalOrders.EDI.detailItems"),
                    name: "items",
                  },
                },
                [
                  _c(
                    "el-table",
                    {
                      attrs: {
                        data: _vm.detailData.lines,
                        size: "mini",
                        border: "",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "upcCode",
                          label: _vm.$t("ExternalOrders.EDI.detailSku"),
                          width: "240",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "quantity",
                          label: _vm.$t("ExternalOrders.EDI.detailQty"),
                          width: "100",
                          align: "center",
                        },
                      }),
                      _c("el-table-column", {
                        attrs: {
                          prop: "status",
                          label: _vm.$t("ExternalOrders.EDI.detailMatch"),
                          align: "center",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.status == 1
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "success",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "ExternalOrders.EDI.MatchStatus1"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                scope.row.status == 0
                                  ? _c(
                                      "el-tag",
                                      {
                                        attrs: { size: "mini", type: "danger" },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "ExternalOrders.EDI.MatchStatus2"
                                            )
                                          )
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              !_vm.$store.getters.cusId
                ? _c(
                    "el-tab-pane",
                    { attrs: { name: "payload" } },
                    [
                      _c("template", { slot: "label" }, [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t("ExternalOrders.EDI.detailEdiPayload")
                            )
                          ),
                        ]),
                        _c("span", { staticClass: "tab-tips" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("ExternalOrders.EDI.detailInternalOnly")
                            )
                          ),
                        ]),
                      ]),
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 9,
                          disabled: true,
                          resize: "none",
                        },
                        model: {
                          value: _vm.ediPayload,
                          callback: function ($$v) {
                            _vm.ediPayload = $$v
                          },
                          expression: "ediPayload",
                        },
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "drawer-footer" },
        [
          _vm.detailData.statusLabel == "exception"
            ? _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.onRetry } },
                [_vm._v(_vm._s(_vm.$t("ExternalOrders.page.retryBtn")))]
              )
            : _vm._e(),
          _c(
            "el-button",
            { attrs: { size: "mini" }, on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("ExternalOrders.EDI.detailClose")))]
          ),
          _vm.canApprove
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "mini" },
                  on: { click: _vm.onApprove },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("ExternalOrders.EDI.detailApproveAndContinue")
                    )
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }